var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-page',{attrs:{"icon":"mdi-database-cog","title":"Client manufacturers","actions":[{
        icon: 'mdi-plus',
        title: 'Add new manufacturer',
        route: {name: 'ManufacturerAdd'},
        variant: 'success'
      }]}},[_c('paginated-result-loader',{attrs:{"title":"Manage manufacturers","listeners":['manufacturerUpdated'],"enable-exports":false,"namespace":"manufacturers"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('manufacturer-list',{attrs:{"items":props.items}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }